﻿// LocalStorage Keys
export const LOCAL_STORAGE_NAMES = {
    CLIENT_TOKEN_NAME: 'token',
    CURRENT_USER: 'user',
    CULTURES: 'cultures',
    SELECTED_CULTURE: 'cultureId',

};

// Cookie Names
export const COOKIE_NAMES = {
    SESSION_TIME: 'expiracaoCookie',
};

export const PROXY_NAMES = {
    ICARUS_URL: '/system',
};

export const ROLE_NAMES = {
    ADMINISTRATOR: 'Administrator',
    SUPER_ADMIN_CLIENT: 'SuperAdminClient',
    BROKER_USER: 'BrokerUser',
    VARIABLES: 'ViewVariables',
    EDIT_VARIABLES: 'EditVariables',
    VALUATIONS: 'Valuations',
    FIELDS: 'Fields',
    RULES: 'Rules',
    LOG: 'Log',
    CONFIGURATION_LOG: 'ConfigurationLog',
    ENTIDADE: 'Entidade',
    PLAN_GROUP: 'PlanGroup',
    EDIT_EMAIL_TEMPLATES: 'EditEmailTemplates',
    REPORT: 'Report',
    BUILD_REPORTS: 'BuildReports',
    READONLY: 'ReadOnly'
  };

export const CLAIM_NAMES = {

}
